module.exports = __webpack_public_path__ + "f2eddd10283f21a6d83f8bf5117b41f3.mtl";